<template>
  <div class="bg-white" v-if="!loading">
    <div class="main-width">
      <div class="gallery" id="gallery">
        <div class="scroll-nav-wraper">
          <v-affix class="fixed" relative-element-selector="#gallery" :offset="{ top: 186, bottom: 60 }"
                   :scroll-affix="false">
            <scroll-active class="scroll-nav" highlight-first-item tag="ul" :offset="70">
              <li v-for="(item, nn) in tabList" :key="nn" class="scroll-nav-item scrollactive-item"
                  :data-section-selector="`.gallery-item__${nn}`">
                <i class="ficon" :class="gallerykey(item.title)"/>
                <span>{{ item.title }}</span>
              </li>
            </scroll-active>
          </v-affix>
        </div>
        <div class="gallery-main">
          <div class="self-start breadcrumb">
            <el-breadcrumb class="my-[25px] ml-[2px]" separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="`/company/cruise/${cruiseId}`">邮轮详情</el-breadcrumb-item>
              <el-breadcrumb-item>图片库</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="gallery-content">
            <div class="cruise-info">
              <nuxt-link :to="`/company/cruise/${cruiseId}`">
                <img :src="cruiseData.logo" class="logo"/>
              </nuxt-link>
              <nuxt-link :to="`/company/cruise/${cruiseId}`">
                <div class="cruise-info-name">
                  <span>{{ cruiseData.name }}</span>
                  <em>{{ cruiseData.en_name }}</em>
                </div>
              </nuxt-link>
              <div class="deck">图片库</div>
            </div>

            <div v-for="(item, nn) in cruise_images" :key="`gallery-item__${nn}`" class="gallery-item"
                 :class="`gallery-item__${nn}`" :id="item.name">
              <div class="gallery-title" :class="item.title === '外观' ? 'my24' : 'my40'">
                <em class="gallery-block__back"></em>
                <em class="gallery-block__orange"></em>
                <span>{{ item.title }}({{ item.num }})</span>
                <img src="@/assets/img/company/brand/brand-title.png" alt=""/>
              </div>
              <ul class="gallery-images">
                <!--外观-->
                <template v-if="item.title === '外观'">
                  <li v-for="(child, cIndex) in item.list" :key="`item_${DateKey}_${nn}_${cIndex}`">
                    <el-image :src="child.url.mid" fit="cover" @click="getTabItemName(item.name, child.url.mid)">
                    </el-image>
                    <span>{{ child.name }}</span>
                  </li>
                </template>
                <!--其它-->
                <template v-else>
                  <li v-for="(nItem, nIndex) in item.ImgList" :key="`nItem_${DateKey}_${nIndex}`">
                    <el-image :src="nItem.mid" fit="cover" @click="getTabItemName(item.name, nItem.mid)"></el-image>
                    <span>{{ nItem.name }}</span>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ImagePreviewView ref="ImagePreviewView"></ImagePreviewView>
  </div>
</template>

<script>
import ImagePreviewView from "@/views/company/components/ImagePreviewView.vue";

import ScrollActive from "@/components/ScrollActive";
import VAffix from "@/components/VAffix";
import {getCruiseImages} from "@/services/company";

import {
  ref,
  useFetch,
  useMeta,
  useRoute,
  defineComponent,
  computed,
} from "@nuxtjs/composition-api";

import {TABS, FontIcon} from "@/constants/galleryEnum";

export default defineComponent({
  name: "GalleryDetail",
  layout: "Main",
  auth: false,
  components: {ScrollActive, VAffix, ImagePreviewView},
  head: {},
  setup() {
    const DateKey = Date.now();
    const route = useRoute();
    const cruiseId = computed(() => {
      return route.value.query.cruiseid;
    });
    const cruiseData = ref({
      name: "",
      en_name: "",
      logo: "",
    });
    const tabList = ref([]);
    const cruise_images = ref([]);
    const loading = ref(true);
    const execute = async () => {
      const {code, data} = await getCruiseImages({
        cruise: cruiseId.value,
      });
      if (code !== 10000) {
        return false;
      }
      loading.value = false;
      let {name, logo, en_name, images} = data;
      Object.assign(cruiseData.value, {name, logo, en_name});
      tabList.value = images.map((item) => {
        return {
          title: item.title,
        };
      });

      cruise_images.value = images.map((pItem) => {
        let {name} = tabs.value.find((item) => item.title === pItem.title);
        if (name !== "appearance") {
          pItem.tempList = [];
          pItem.ImgList = [];
          pItem.list.forEach((listItem) => {
            pItem.tempList.push(...listItem[name]);
          });

          pItem.tempList.map((item) => {
            var item11 = item;
            let ImgList = item.images.map((items) => {
              return {
                ...items,
                introduction: item11.introduction,
              };
            });
            pItem.ImgList.push(...ImgList);
          });
        }
        return {
          ...pItem,
          name,
        };
      });
    };
    useFetch(async () => {
      await execute(0);
    });
    useMeta(() => ({
      title: cruiseData.value.name+"图片信息,外观,舱房,美食,娱乐,服务,上船吧邮轮平台",
      meta: [
        {
          name: "description",
          content: `上船吧邮轮平台为您提供${cruiseData.value.name}图片信息展示，包括邮轮外观,舱房,美食,娱乐,服务等图片信息等`,
          hid: "description",
        },
        {
          name: "keywords",
          hid: "keywords",
          // content: cruiseData.value.name+",邮轮图片,外观,舱房,美食,娱乐,服务【上船吧邮轮平台】",
          content: `${cruiseData.value.name}邮轮图片,${cruiseData.value.name}外观,${cruiseData.value.name}舱房,${cruiseData.value.name}美食,${cruiseData.value.name}娱乐,${cruiseData.value.name}服务`
        },
      ],
    }));

    const fontIcon = ref([...FontIcon]);
    const gallerykey = (value) => {
      let {name} = fontIcon.value.find((item) => item.title === value);
      return name;
    };

    const tabs = ref([...TABS]);
    const ImagePreviewView = ref(null);
    const getTabItemName = (name, imgPath) => {
      ImagePreviewView.value.setData(
          name,
          imgPath,
          route.value.query.cruiseid,
          cruise_images.value
      );
    };

    return {
      cruiseId,
      DateKey,
      cruiseData,
      cruise_images,
      tabList,
      ImagePreviewView,
      loading,
      gallerykey,
      getTabItemName,
    };
  },
});
</script>

<style lang="scss" scoped>
::v-deep .breadcrumb {
  font-size: 15px;
}
::v-deep .breadcrumb .is-link {
  font-weight: 500;
}
.main-width {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin: auto;
  width: 1367px;
}
.main-width .gallery {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.main-width .gallery .scroll-nav-wraper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  width: 90px;
}
.main-width .gallery .scroll-nav-wraper .scrollactive-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.main-width .gallery .scroll-nav-wraper .scrollactive-nav .scroll-nav-item {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 38px;
  margin-bottom: 10px;
  text-align: center;
  width: 90px;
}
.main-width .gallery .scroll-nav-wraper .scrollactive-nav .scroll-nav-item .ficon {
  margin-right: 12px;
  width: 16px;
}
.main-width .gallery .scroll-nav-wraper .scrollactive-nav .scroll-nav-item .ficon::before {
  font-size: 14px;
}
.main-width .gallery .scroll-nav-wraper .scrollactive-nav .scroll-nav-item span {
  font-weight: 500;
  font-size: 15px;
}
.main-width .gallery .scroll-nav-wraper .scrollactive-nav .ficon-gongzuorenyuan::before {
  font-size: 16px;
}
.main-width .gallery .scroll-nav-wraper .scrollactive-nav .is-active {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 33, 41, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  border-radius: 4px;
}
.main-width .gallery-main {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  margin-left: 20px;
  min-height: 1200px;
  width: 1256px;
}
.main-width .gallery-main .cruise-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  width: 100%;
}
.main-width .gallery-main .cruise-info .logo {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  height: 28px;
  margin-top: 9px;
  width: 77px;
  filter: drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.2));
}
.main-width .gallery-main .cruise-info-name {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.main-width .gallery-main .cruise-info-name span {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  font-size: 28px;
}
.main-width .gallery-main .cruise-info-name em {
  font-weight: 400;
  margin-top: 3px;
  --tw-text-opacity: 1;
  color: rgba(182, 182, 182, var(--tw-text-opacity));
  font-size: 13px;
}
.main-width .gallery-main .cruise-info .deck {
  font-weight: 500;
  line-height: 21px;
  margin-top: 1rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  font-size: 15px;
}
.main-width .gallery-main .gallery-title {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-weight: 500;
  height: 48px;
  line-height: 48px;
  padding-left: 16px;
  position: relative;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  width: 100%;
  background: linear-gradient(350.09deg, #ffffff 7.43%, #f7f8fc 78.35%);
}
.main-width .gallery-main .gallery-title .gallery-block__back {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  height: 14px;
  position: absolute;
  left: 16px;
  top: 16px;
  width: 7px;
  z-index: 2;
}
.main-width .gallery-main .gallery-title .gallery-block__orange {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 91, 59, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  height: 16px;
  position: absolute;
  left: 19px;
  bottom: 13px;
  width: 10px;
  z-index: 1;
}
.main-width .gallery-main .gallery-title span {
  margin-left: 1.25rem;
  margin-top: 2px;
  font-size: 18px;
}
.main-width .gallery-main .gallery-title img {
  height: 19px;
  margin-left: -12px;
  margin-top: 11px;
  width: 19px;
}
.main-width .gallery-main .my24 {
  margin-top: 24px;
  margin-bottom: 24px;
}
.main-width .gallery-main .my40 {
  margin-top: 36px;
  margin-bottom: 40px;
}
.main-width .gallery-main .gallery-images {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  margin-bottom: 40px;
  width: 100%;
}
.main-width .gallery-main .gallery-images .item {
  display: inline-block;
}
.main-width .gallery-main .gallery-images li {
  cursor: pointer;
  height: 208px;
  margin-right: 4px;
  margin-bottom: 4px;
  position: relative;
  width: 311px;
  font-size: 0;
}
.main-width .gallery-main .gallery-images li .el-image {
  height: 208px;
  width: 311px;
}
.main-width .gallery-main .gallery-images li span {
  font-weight: 500;
  line-height: 20px;
  padding-left: 8px;
  padding-right: 8px;
  padding-left: 6px;
  padding-right: 6px;
  position: absolute;
  left: 8px;
  bottom: 8px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  z-index: 2;
  background: rgba(0, 0, 0, 0.5);
  font-size: 14px;
  border-radius: 2px;
}
.main-width .gallery-main .gallery-images li:nth-child(4n) {
  margin-right: 0px;
}
</style>
